module.exports = __webpack_public_path__ + "static/media/kfc-24-62.a9cce681.jpg";